export const lang = {
  //選單
  menu: {
    Home: "首頁",
    device: "裝置管理",
    devicelist: "裝置清單",
    groupinglist: "分組清單",
    unusuallist: "異常列表",
    resource: "配置管理",
    configuration: "配置清單",
    configurationlist: "裝置配置",
    firmware: "批次配置",
    alarmMsg: "故障管理",
    historywarn: "歷史警告",
    warnconfiguration: "警告配置",
    currenttimewarn: "即時警報",
    diagnosemessage: "診斷訊息",
    graphs: "統計報表",
    onlinerate: "線上費率",
    flowstatistics: "流量統計",
    signalstatistics: "訊號統計",
    Softwareversion: "軟體版本",
    task: "軟體管理",
    softwarepackage: "韌體管理",
    upgrade: "軟體任務",
    system: "系統管理",
    Authoritymanagement: "安全管理",
    customermanagement: "客戶管理",
    usercontrol: "使用者管理",
    parametermanagement: "參數管理",
    RemoteService: "遠端服務",
    AlarmContact: "警告聯絡人",
    North: "北向三方",
    PrinterDriver: "驅動程式管理",
    HangingDevice: "印表機清單",
  },
  //表格元件
  TableComponent: {
    operating: "操作",
    edit: "編輯",
    delete: "刪除",
    loading: "正在取得資訊...",
    empty: "暫無資料",
    loadingFail: "資料載入失敗",
    serialNumber: "序號",
  },
  //登入頁
  login: {
    LoginTitle: "物聯網雲端平台",
    userDisplay: "使用者登入",
    user_isloggedin: "請輸入使用者名稱或信箱",
    Password_By_Supervisor: "請輸入密碼",
    http_login: "立即登入",
    viewport: "使用者名稱或密碼錯誤,請檢查後重新輸入",
    password_short: "密碼過短",
  },
  //路由
  router: {
    Dashboard: "首页",
    Index: "首页",
    Login: "物联网云平台",
    Gateone: "远程操作",
    Device: "设备管理",
    Particulars: "设备详情",
    DeviceList: "设备列表",
    CloudMonitorDeviceList: "设备列表",
    Unusuallist: "异常设备列表",
    GroupingList: "分组列表",
    AlarmMsg: "故障管理",
    Historywarn: "历史告警",
    Warnconfiguration: "告警配置",
    Currenttimewarn: "实时报警",
    Diagnosemessage: "诊断信息",
    Graphs: "统计报表",
    Onlinerate: "在线率",
    Flowstatistics: "流量统计",
    Signalstatistics: "信号统计",
    Softwareversion: "软件版本",
    Resource: "配置管理",
    Configurationlist: "设备配置",
    Firmware: "批量配置",
    Configuration: "配置列表",
    Task: "任务管理",
    Upgrade: "软件任务",
    Softwarepackage: "固件管理",
    System: "系统管理",
    Authoritymanagement: "安全管理",
    Customermanagement: "客户管理",
    Operationlog: "操作日志",
    Enterlog: "登录日志",
    Usercontrol: "用户管理",
    Parametermanagement: "参数管理",
    RemoteService: "远程服务",
    AlarmContact: "告警联系人",
    North: "北向三方",
    PrinterDriver: "驱动管理",
    HangingDevice: "打印机列表",
    /**
     * 云监测
     */
    FastAccess: "快速接入",
    MonitoringScreen: "监控大屏",
    ProjectGroup: "项目列表",
    TerminalList: "终端列表",
    CloudMonitorTerminalList: "终端列表",
    CollectConfigurate: "采集配置",
    EditCollection: "添加变量",
    AddDevice: "添加设备",
    AddTerminal: "添加终端",
    AlarmNotice: "报警通知",
    AlarmContact: "报警联系人",
    AlarmList: "报警记录",
    HistoryRecords: "历史记录",
    DevicesStatus: "设备上下线",
    variableList: "变量列表",
  },
  //首頁
  dashboard: {
    Equipment: "設備線上匯總",
    offline: "離線設備",
    online: "線上設備",
    form: "佔比",
    summary: "設備數量總計",
    chieffinancialofficer: "物聯網關",
    Router: "路由器",
    PrintStream: "列印伺服器",
    Serial: "串流伺服器",
    Other: "其它",
    Serials: "序號",
    name: "名稱",
    ADDRESS: "位址",
    OfflineDevice: "離線裝置",
    OnlineDevice: "線上設備",
    AllDevices: "所有設備",
    message1: "兩次輸入密碼不一致",
    message2: "使用者密碼由任意數字、字串、底線組成，必須超過6位小於16位",
    message3: "修改成功",
    message4: "操作失敗",
    message5: "不支援全螢幕",
    Amap: "高德地圖",
    google: "Google地圖",
    emailError: "請輸入正確的信箱",
    activateTips: "驗證郵件已發送您的郵箱，請在30分鐘內啟動",
    userPWDError: "使用者密碼不正確",
    oldPWDError: "修改失敗，舊密碼不正確",
  },
  //首頁頭像內容
  user: {
    Personal: "個人資料",
    ChangePassword: "修改密碼",
    exit: "退出",
    User: "使用者名稱",
    NICKNAME_RE: "使用者暱稱",
    UserRelated: "使用者姓名",
    Gender: "性別",
    Phones: "手機號碼",
    social: "QQ/微信",
    Email: "郵件信箱",
    software: "使用者位址",
    recently: "最近登入",
    modify: "修改",
    Male: "男",
    Female: "女",
    OldPassword: "舊密碼",
    NewPassword: "新密碼",
    Confirm: "確認密碼",
    cancel: "取消",
    Confirmation: "確認",
    badconfirmstr: "確認修改",
    BindingEmail: "郵件信箱綁定",
    EmailAddress: "郵件地址",
    VerifyPassword: "驗證密碼",
    中文: "簡體中文",
    EmailBinding: "郵件信箱綁定",
  },
  // 個人資料
  //axios攔截提示
  http: {
    prompt: "提示",
    Text: "登入狀態已過期，請重新登入!",
    Buttom: "重新登入",
  },
  //裝置列表
  devicelist: {
    SerialNumber: "序號",
    Serial: "序號",
    Equipment: "設備分組",
    DeviceName: "裝置名稱",
    IP: "IP位址",
    statevoid: "狀態",
    traffic: "流量",
    signal: "訊號強度",
    racingnetwork: "網路製式",
    XoopsOnlineHandler: "線上時間",
    TimeSeries: "上線/離線時間",
    Version: "軟體版本",
    schemaLocation: "裝置位置",
    Operation: "操作",
    Please: "請選擇相關操作",
    restart: "重啟設備",
    Factory: "恢復原廠設定",
    Backup: "備份設定檔",
    personsto: "取得裝置日誌",
    Timer: "定時重開機",
    Prototype: "取消定時重開機",
    reloadM2M: '重啟M2M服務',
    batch_groups_path: "批次修改分組",
    batch: "不刷新",
    L5Nrefresh: "5秒刷新",
    L10Nrefresh: "10秒刷新",
    L20Nrefresh: "20秒刷新",
    L60Nrefresh: "60秒刷新",
    connected: "已連線",
    not: "未連接",
    Disconnect: "斷開遠端連線",
    changes: "修改分組",
    Primary: "一級分組",
    secondary: "二級分組",
    highlevel: "三級分組",
    PLEASE: "請選擇",
    Choose: "不選",
    Determine: "確定",
    CancelTst: "取消",
    removed: "刪除裝置",
    message1: "刪除成功",
    message2: "刪除失敗",
    message3: "未選取設備",
    message4: "修改成功",
    message5: "修改失敗",
    message6: "目前選取有未上線的裝置",
    message7: "此操作只允許單一裝置操作",
    message8: "請選擇裝置再進行操作",
    message9: "連線成功",
    message10: "連線失敗",
    message11: "正在建立連線",
    message12: "成功斷開",
    message13: "操作失敗",
    message14: "裝置名稱不能為空",
    message15: "修改成功",
    message16: "修改失敗",
    message17: "設備位置不能為空",
    search1: "序號搜尋",
    search2: "裝置分組",
    search3: "設備名稱",
    search4: "IP位址",
    search5: "狀態",
    search6: "流量",
    search7: "訊號",
    search8: "網路製式",
    search9: "線上時間",
    search10: "上線/離線時間",
    search11: "軟體版本",
    search12: "裝置位置",
    FirstLevelProject: "所屬一級分組",
    SecondLevelProject: "所屬二級分組",
    DeviceAddress: "設備位址",
    Name: "名稱",
    connecttodevice: '連接到裝置',
    Disconnect: '斷開連線',
    disbad: "斷開失敗",
    WANPortTraffic: 'WAN埠流量',
    _3GWAN1Traffic: '3G WAN1流量',
    _3GWAN2Traffic: '3G WAN2流量',
    repair: '確定要修復此裝置嗎？ ',
    progress: '執行中...',
    contactCustomerService: '執行成功，如設備任然存在異常，請聯絡客服!',
    Detection: '設備偵測',
    confirmRepir: '確定要對所有可能有問題的設備進行檢測與修復嗎？ ',
    waitRun: '等待執行...',
    noDeviceRepair: '暫無設備需要修復',
    total: '總數',
    success: '成功',
    fail: '失敗',
  },
  gateone: {
    closeTips: "關閉提示",
    isUsed: "裝置遠端連線已經被使用",
    successConect: "連線成功",
    failConnect: "連線失敗",
    connecting: "正在建立連線",
  },
  //設備遠端操作組件
  Dialog: {
    affected: "受影響設備",
    cancel: "取消",
    Determine: "確定",
    translators: "選擇時間",
    interface: "介面序號",
    prompt: "提示",
    Weltordnung: "取得成功",
    download: "立即下載",
    Monday: "週一",
    Tuesday: "週二",
    Wednesday: "週三",
    Thursday: "週四",
    Friday: "週五",
    saturday: "週六",
    sunday: "週日",
    Backup: "備份設定檔",
    personsto: "取得裝置日誌",
    SkinVector: "取得成功",
    allocator: "獲取中",
    WaitForMultipleObjects: "取得失敗",
    operation: "操作成功",
    BoxapiJSONOperation: "操作失敗",
    remoteservice: "遠端服務",
    executing: "正在執行，請勿重複操作!",
  },
  //設備詳細信息
  particulars: {
    modify: "修改",
    Add: "新增遠端服務",
    batch: "不刷新",
    L5Nrefresh: "5秒刷新",
    L10Nrefresh: "10秒刷新",
    L20Nrefresh: "20秒刷新",
    L60Nrefresh: "60秒刷新",
    WAD_NUMBER_RETURN: "返回",
    SystemUptime: "系統資訊",
    DeviceName: "裝置名稱",
    Grouping: "設備分組",
    Professional: "系統名稱",
    Models: "主機型號",
    Version: "軟體版本",
    Kernel: "核心版本",
    Product: "產品型號",
    Serial: "序號",
    Hardware: "硬體類型",
    hardware: "硬體版本",
    mac: "MAC位址",
    network: "網路模式",
    VendorModel: "廠商",
    deviceID: "裝置ID",
    ADDRESS: "位址",
    detailed: "詳細地址",
    UpgradeTime: "更新時間",
    Customer: "客戶",
    StateManager: "狀態資訊",
    connection: "連線狀態",
    foreach: "首次登入時間",
    CurTime: "線上總時長",
    beforeoffline: "離線總時數",
    TimeModeSetOffline: "本次離線時間",
    SCLocalTime: "本離線時長",
    LoginTime: "本次登入時間",
    online_updated: "本次在線時長",
    NetworkTraffic: "網路流量",
    GeneralInfo: "概覽",
    traffic: "今日流量",
    Monthly: "本月流量",
    software: "最近7天流量",
    addToTrafficDensityMap: "總流量",
    WAN: "有線廣域網路狀態",
    IP: "IP位址",
    gateway: "網關",
    NonContiguousSubnetMask: "子網路遮罩",
    NETWORK: "網路協定",
    DNS1: "DNS1",
    DNS2: "DNS2",
    NETWORK_FAUX_QUEUE: "連線時長",
    Connection: "連線狀態",
    UpdateTime: "更新時間",
    wan3g1: "行動網路狀態（3gwan1）",
    wan3g2: "行動網路狀態（3gwan2）",
    wan3g1Tag1: "行動網路狀態（3gwan1雲鷹卡）",
    wan3g1Tag2: "行動網路狀態（3gwan2雲鷹卡）",
    wan3g1IP: "IP位址",
    wan3g1IPV6: "IPV6位址",
    wan3g1gateway: "網關",
    wan3g1NonContiguousSubnetMask: "子網路遮罩",
    wan3g1NETWORK: "網路協定",
    wan3g1DNS1: "DNS1",
    wan3g1DNS2: "DNS2",
    MODULE_FILE_SUFFIX: "模組型號",
    Operator: "操作員",
    supported: "支持制式",
    IMSI: "IMSI",
    IMEI: "IMEI",
    ICCID: "ICCID",
    current: "目前網路製式",
    SignalStrengths: "訊號強度",
    SIM: "SIM狀態",
    wan3g1NETWORK_FAUX_QUEUE: "連線時長",
    wan3g1Connection: "連線狀態",
    wan3g1UpdateTime: "更新時間",
    profile: "有線區域網路狀態",
    profileIp: "IP位址",
    profilegateway: "網關",
    profileNonContiguousSubnetMask: "子網路遮罩",
    profileNETWORK: "網路協定",
    profileConnection: "連線狀態",
    profileUpdateTime: "更新時間",
    GPS: "GPS資訊",
    long: "經度",
    lat: "緯度",
    service: "遠端服務資訊",
    YTCommunityTag: "社群名",
    password: "密碼",
    YTCommuniIP: "IP",
    Operation: "操作",
    statusClear: "線上/離線時長清零",
    rthq_infobase: "基地台資訊",
    MNC: "MNC",
    MCC: "MCC",
    LocationListener: "位置資訊",
    networkRemoveOk: "網路類型",
    unknown: "未知",
    connected: "已連線",
    not: "未連接",
    blendmode: "單模單卡",
    discard_year: "單模雙卡",
    SerialServer: "字串伺服器",
    PrintServer: "列印伺服器",
    model_id: "雙模雙卡",
    MultiSimVariants: "多模多卡",
    Modeling: "有線模式",
    G4G5: "4G/5G模式",
    G3G4: "3G/4G模式",
    compatibility: "相容模式",
    addressStrings: "靜態位址",
    refreshHaves: "已插卡",
    info_normal_color: "未插卡",
    package_pin: "無pin碼",
    IMEI_CODE_LEN: "無PUK碼",
    aac_card_type: "卡片異常",
    AtomServiceDualParser: "刪除遠端服務",
    si_modify: "修改",
    reset_type: "重設",
    Day: "天",
    hours: "小時",
    minutes: "分鐘",
    seconds: "秒",
    GPSrequire: "(GPS回報)",
    Processmanagement: "系統服務",
    Processname: "服務名稱",
    Processstatus: "服務狀態",
    Processcontrol: "服務控制",
    ProcessDate: "更新時間",
    Devicenotonline: "設備未線上",
    NotSupport: "裝置不支援該功能",
    dropbear: "SSH訪問",
    smartlink: "智慧物聯",
    smartnms: "網管服務",
    uhttpd: "Web服務",
    loc: "定位服務",
    watchcat: "網路監控",
    "ss-redir": "連結聚合",
    configmgr: "配置服務",
    m2mMqtt: "m2mMqtt",
    watchfox: "4G監控",
    firewall: "防火牆",
    M2MProxy: "M2M平台",
    smartm2m: "M2M平台",
    mwan3: "負載平衡",
    socat: "中繼器",
    smartcat: "中繼器",
    smartant: "管理服務",
    openvpn: "OpenVPN",
    repeater: "中繼器",
    IOControl: "IO控制",
    ipsec: "IPSec",
    eoip: "EOIP",
    pptp1: "PPTP",
    gre1: "GRE",
    wlan0: "WIFI",
    l2tp1: "L2TP",
    Running: "運作中",
    Stop: "停止",
    startup: "啟動",
    Restart: "重啟",
    operation: "操作成功",
    BoxapiJSONOperation: "操作失敗",
    message1: "目前設備未上線",
    message2: "此操作將為該設備新增遠端服務",
    message3: "提示",
    message4: "確定",
    message5: "取消",
    message6: "新增成功",
    message7: "新增失敗",
    message8: "取消新增",
    message9: "目前設備未上線",
    message10: "此操作將刪除該裝置遠端服務",
    message11: "刪除成功",
    message12: "刪除失敗",
    message13: "取消刪除",
    message14: "確定修改設備經度為",
    message15: "修改成功",
    message16: "修改失敗",
    message17: "緯度為",
    wan2: "行動網路狀態（3gwan2）",
    wirelessWifi: "無線wwan網路",
    networkStatus: "網路狀態",
    disOpened: "未啟用",
    trafficClear: "流量清零",
    hanging: "下掛設備",
    OnlineTimes: "上線次數",
    OfflineTimes: "下線次數",
    networkMonitoring: "網路監控",
    frpc: 'frpc服務'
  },
  // 無線網路
  wireless: {
    interfaceName: "介面名",
    interfaceStatus: "介面狀態",
    running: "運行中",
    stop: "停止",
    ip: "IP位址",
    subnetMask: "子網路遮罩",
    gateway: "網關位址",
    protocol: "協議",
    DNSServer: "DNS服務",
    hops: "躍點",
    connectTime: "連線時長",
    uplink: "上行流量",
    downlink: "下行流量",
  },
  //分組管理
  groupinglist: {
    GroupName: "分組名稱",
    GroupByTests: "上級分組",
    belonging: "歸屬客戶",
    contact_to: "歸屬使用者",
    Creator: "創作者",
    services: "服務類型",
    account_root: "遠端帳號",
    RemoteMailboxes: "遠端密碼",
    IPaux: "遠端IP",
    Update: "更新時間",
    Operation: "操作",
    Add: "新增",
    Migrate: "遷移",
    MigrationGroup: "遷移分組",
    N2nVersion: "版本",
    port: "端口",
    loadData: "新增分組",
    optional_groups: "修改分組",
    group1: "一級分組",
    group2: "二級分組",
    AllowMultipleLogins: "允許多處登入",
    DonotAllowmultiplelogins: "不允許多處登入",
    cancel: "取消",
    Determine: "確定",
    GroupDef_delete: "刪除分組",
    message1: "長度為大於6位元小於18位元",
    message2: "遠端密碼必須大於6位元小於18位元",
    message3: "遠端ip輸入有誤，請檢查",
    message4: "修改成功",
    message5: "群組名稱重複",
    message6: "遠端帳號名稱重複",
    message7: "分組下存在設備，無法刪除",
    message8: "操作失敗",
    message9: "請新增遠端帳號資訊",
    message10: "預設分組無法被刪除",
    message11: "刪除成功",
    message12: "刪除失敗",
    message13: "新增成功",
    message14: "操作失敗",
    message15: "遷移成功",
    message16: "遷移失敗",
    message17: "請選擇分組",
    platformprint: "遠端列印",
    ReconStandardServicePanel: "標準服務",
    Standard: "必填",
    Optional: "選填",
    selector: "請選擇",
    Choose: "不選",
    search1: "分組名稱",
    search2: "上級分組",
    search3: "歸屬客戶",
    search4: "創作者",
    search5: "服務類型",
    search6: "遠端帳號",
    search7: "遠端密碼",
    search8: "遠端IP",
    search9: "更新時間",
    search10: "歸屬使用者",
    userpwdChineseCheck: "帳號、密碼不能包含中文",
    notEmpty: "不能為空",
    ipInput: "請輸入遠端IP",
    groupNameInput: "請輸入分組名稱",
    firstLevelGrouping: "一級分組",
    secondaryGrouping: "二級分組",
    threelevelgrouping: "三級分組",
    GroupingLevel: "分組等級",
    mobileGrouping: "移動分組",
    bridging: "橋接",
    // 遠端橋接
    remoteBridge: "遠程橋接",
    // 橋接提示
    bridgePrompt: "勾選橋接時，遠端IP位址將被設定為和網關LAN IP預設位址一樣（192.168.1.1），此時Superlink網路可以用本地區域網路方式存取網關LAN下掛終端。",
    bridgePrompt2: "取消勾選橋接時，遠端IP位址將被還原為預設的IP位址（172.16.100.2）。此時Superlink網路將以遠端跨網段方式存取網關LAN下掛終端。",
    // 橋接提示
    bridgePrompt3: "此遠端服務版本不支援橋接"
  },
  //異常設備列表
  unusuallist: {
    Serial: "序號",
    DeviceName: "裝置名稱",
    Version: "軟體版本",
    DeleteTime: "刪除時間",
    Operation: "操作",
    prompt: "提示",
    Tetx: "將設備恢復到設備清單中, 是否繼續?",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
    success: "恢復成功",
    RestoreMetaData: "復原失敗",
    search1: "輸入序號",
    search2: "輸入設備名稱",
    search3: "輸入軟體版本",
    search4: "輸入刪除時間",
  },
  //配置列表
  configuration: {
    createFile: "檔案名稱",
    ntfs_file_open: "檔案大小(KB)",
    heir_do: "上傳人",
    Upload: "上傳時間",
    noteId: "備註",
    Operation: "操作",
    Add: "新增",
    Configuration: "新增設定檔",
    add_action: "點擊上傳",
    file_name: "檔案格式必須為.tar.gz",
    uploaders: "上傳",
    modifycollection: "修改設定檔",
    justUploaded: "上傳成功",
    successfully: "上傳失敗",
    TestDelete: "刪除成功",
    bdb_delete: "刪除失敗",
    m_pr_modifyS: "修改成功",
    onCallModifying: "修改失敗",
    t_config_file: "刪除設定檔",
    databases: "此操作將永久刪除該資料, 是否繼續?",
    Determine: "確定",
    cancel: "取消",
    Optional: "選填",
    search1: "請輸入檔案名稱",
    search2: "請輸入檔案大小",
    search3: "請輸入上傳者",
    search4: "請輸入上傳時間",
    search5: "請輸入備註",
  },
  //設備配置
  ConfigSetting: {
    successSetting: "配置成功",
    failSetting: "配置失敗",
    L2TP: "L2TP",
    PPTP: "PPTP",
    bandwidth: "頻寬",
    channel: "通道",
    GroupSelection: "分組選擇",
    Searchgroup: "搜尋分組",
    DeviceSelection: "設備選擇",
    pleaseChoose: "請選擇",
    Protocol: "協議",
    Staticaddress: "靜態位址",
    DHCPclient: "DHCP 用戶端",
    IPv4address: "IPv4 位址",
    IPv4netmask: "IPv4 子網路遮罩",
    UsecustomDNSservers: "使用自訂的DNS 伺服器",
    SaveApply: "儲存並套用",
    DHCP: "請求 DHCP 時發送的主機名稱",
    IPv4gateway: "IPv4閘道",
    NetworkType: "網頁類型",
    Automatic: "自動",
    PAPCHAPusername: "PAP/CHAP 使用者名稱",
    PAPCHAPpassword: "PAP/CHAP 密碼",
    custom: "自訂",
    AuthenticationType: "認證類型",
    ICMPCheck: "ICMP 偵測",
    Disable: "禁用",
    Enable: "開啟",
    ServiceType: "服務類型",
    Dialnumber: "撥號",
    LocalIPAddress: "本機介面ip位址",
    Hostname: "主機名稱",
    Timezone: "時區",
    Language: "語言",
    WANMode: "WAN模式",
    andWired: "相容模式",
    Wired: "有線模式",
    G3G4: "3G/4G模式",
    G4G5: "4G/5G模式",
    NTPclient: "啟用 NTP 用戶端",
    NTPserver: "以 NTP 伺服器提供服務",
    servercandidates: "候選 NTP 伺服器",
    WebAccess: "Web存取",
    Changes: "修改存取Web控制台的連接埠",
    Port: "連接埠",
    SSHAccess: "SSH存取",
    Dropbear: "Dropbear 提供 SSH 存取權和 SCP 服務",
    Interface: "介面",
    unspecified: "未指定",
    Passwordauthentication: "密碼驗證",
    withpassword: "允許 root 使用者憑密碼登入",
    Gatewayports: "網關埠",
    ADD: "新增",
    protection: "SYN-flood 防禦",
    Dropinvalidpackets: "無效資料包",
    Input: "入站資料",
    Output: "出站資料",
    Forward: "轉寄",
    accept: "接受",
    drop: "丟棄",
    reject: "拒絕",
    ModeUrl: "網域過濾",
    Disables: "禁用",
    while: "白名單",
    black: "黑名單",
    Domain: "網域",
    Name: "名字",
    Externalzone: "外部區域",
    ExternalIPaddress: "外部連接埠",
    Internalzone: "內部區域",
    InternalIPaddress: "內部連接埠",
    operating: "操作",
    delete: "刪除",
    Other: "其它",
    DISABLE: "禁用",
    DEABLE: "開啟",
    SourceIPaddress: "來源IP位址",
    Rule: "規則",
    ExternalIPaddress: "外部IP位址",
    InternalIPaddress: "內部IP位址",
    Sourceport: "來源埠",
    EnableNATLoopback: "啟用NAT環回",
    Extraarguments: "附加參數",
    edit: "編輯",
    cancel: "取消",
    determine: "確定",
    Ststem: "系統",
    Administration: "管理權",
    Firewall: "防火牆",
    DomainFilter: "網域過濾",
    KeywordFilter: "關鍵字過濾",
    PortForwards: "連接埠轉送",
    M2MPlatform: "M2M平台",
    StartM2MPlatformControl: "啟用M2M平台管理",
    HeartbeatInterval: "心跳包回報頻率(秒)",
    Heartbeattimeouttimes: "心跳包失敗次數",
    reportingFrequency: "定位資料回報頻率(秒)",
    NetStatusInterval: "網路狀態回報頻率(秒)",
    ServerIP: "伺服器IP位址",
    Successfulconfiguration: "配置成功",
    Configurationerror: "設定錯誤",
    Nochangesmade: "未做出修改",
    Pleasecheck: "請檢查輸入內容",
    BasicSettings: "基本設定",
    WirelessNetwork: "無線網路",
    Mode: "模式",
    HideESSID: "隱藏ESSID",
    WMMMode: "WMM模式",
    WirelessSecurity: "無線安全",
    Encryption: "加密方式",
    Key: "金鑰",
    AccesspointAP: "接入點AP",
    wifimessage: "wifi金鑰長度至少為8位元",
    OnOff: "啟動/關閉",
    L2TPServer: "L2TP伺服器",
    PapchapUsername: "PAP/CHAP使用者名稱",
    PapchapPassword: "PAP/CHAP密碼",
    PowerOn: "開機啟動",
    UseDefaultGateway: "使用預設閘道",
    LCPResponseFailureThreshold: "LCP 回應故障閾值",
    LCPResponseInterval: "LCP 回應間隔",
    AdditionalPPPParameters: "額外的PPP參數",
    VpnServer: "VPN 伺服器",
    MPPEEncryption: "MPPE加密方式",
    Smartlink: "智慧物聯",
    smartnms: "網管服務",
    PortalAuthentication: "門戶認證",
    Enable: "啟用",
    isEnable: "已啟用",
    disEnable: "已停用",
    Address: "網址",
    PageUpdate: "頁面更新",
    JumpAddressAfterAuthentication: "認證後跳到地址",
    SessionTimeout: "會話逾時",
    MaximumNumberOfCustomers: "最大客戶數",
    UncertifiedEquipment: "未認證設備",
    CertifiedEquipment: "已認證設備",
    AuthenticationFreeMACAddress: "免認證設備MAC位址",
    IgnoreWiredDevices: "忽略有線設備",
    debug: "調試",
    not: "無",
    error: "錯誤",
    information: "訊息",
    basicConfiguration: "基本配置",
    redirect: "通訊規則",
    name: "名稱",
    protocols: "協議",
    TCP: "TCP",
    TCP_UDP: "TCP+UDP",
    UDP: "UDP",
    ICMP: "ICMP",
    anyone: "任何",
    custom: "--自訂--",
    pleaseInput: "請輸入",
    SRC: "源區域",
    SRCIp: "來源IP位址",
    dest: "目標區域",
    dest_ip: "目標IP位址",
    SNAT: "SNAT IP位址",
    anyoneDest: "任意區域",
    deviceSelectTips: "僅展示連網線上的裝置清單",
    SNSearch: "依據SN篩選",
    filter: "過濾",
    interfaceSetting: "介面配置",
    deiveceSetting: "設備配置",
    trandform: "WAN轉LAN",
    disabled: '已停用',
    UseGatewayHops: '使用網關躍點',
    useTheDns: '使用對端通告的 DNS 伺服器',
    activityTimeout: '活動超時',
    resetMTU: '重設 MTU',
    useTheCustomDns: '使用自訂的 DNS 伺服器',
    GetIPv6address: '取得 IPv6 位址',
    IPSecConfiguration: 'IPSec配置',
    L2TPKey: 'L2TP 金鑰',
    optional: '可選',
    SIMmode: 'SIM卡模式:',
    Dualcardbackup: '雙卡備份:',
    SIM1APNaccesspoint: 'SIM1 APN存取點:',
    SIM1username: 'SIM1 使用者名稱:',
    SIM1password: 'SIM1 密碼:',
    SIM1authenticationtype: 'SIM1 認證類型:',
    SIM1carriermode: 'SIM1 運營商模式:',
    SIM1IPprotocol: 'SIM1 IP協定:',
    ChinaMobile: '中國移動',
    ChinaUnicom: '中國聯通',
    ChinaTelecom: '中國電信',
    SIM1localIPaddress: 'SIM1 本機IP位址:',
    SIM1PINcode: 'SIM1 PIN碼:',
    SIM1cardtype: 'SIM1 卡類型:',
    publicnetworkcard: '公網卡',
    privatenetworkcard: '專網卡',
    SIM1detectionstrategy: 'SIM1 偵測策略',
    RSSIsignal: 'RSSI訊號',
    Pingdelay: 'Ping延遲',
    mixedstrategy: '混合策略',
    SIM1RSSIThreshold: 'SIM1 RSSI閾值:',
    SIM1LatencyThreshold: 'SIM1 延遲閾值:',
    scope1: "當RSSI值低於閾值時，則判斷撥號連線為中斷。取值範圍(0,30)",
    scope2: '當Ping偵測延遲超過閾值時，則判斷撥號連線已中斷。單位為毫秒。取值範圍(100,3000)',
    SIM1detectionaddress: 'SIM1 檢測位址:',
    SIM1detectioncycle: 'SIM1 偵測週期:',
    scope3: '偵測網路連線的頻率,單位為秒',
    SIM1PingCount: 'SIM1 Ping次數:',
    SIM2APNaccesspoint: 'SIM2 APN接入點:',
    SIM2username: 'SIM2 使用者名稱:',
    SIM2password: 'SIM2 密碼:',
    SIM2authenticationtype: 'SIM2 認證類型:',
    SIM2carriermode: 'SIM2 運營商模式:',
    SIM2localIPaddress: 'SIM2 本地IP位址:',
    SIM2PINcode: 'SIM2 PIN碼:',
    SIM2cardtype: 'SIM2 卡類型:',
    SIM2detectionstrategy: 'SIM2 偵測策略',
    SIM2RSSIThreshold: 'SIM2 RSSI閾值:',
    SIM2LatencyThreshold: 'SIM2 延遲閾值:',
    SIM2detectionaddress: 'SIM2 檢測位址:',
    SIM2detectioncycle: 'SIM2 偵測週期:',
    SIM2PingCount: 'SIM2 Ping次數:',
    Restartafternetworkdisconnection: '斷網重開機:',
    AlibabaCloudEagleCard: '阿里雲鷹卡:',
    defaultcarrier: '預設運營商:',
    disabledAccess: '預設禁止Wan Web存取：',
    SIMDefaultConfig: 'SIM預設配置',
    v2tcpServer: 'V2_TCP連線',
    v2mqttServer: 'V2_MQTT連接'
  },
  // 設備配置-> 有線網絡
  wire: {
    wireNetwork: "有線網路",
    normalSetting: "一般配置",
    functionConfiguration: "功能配置",
    DHCPServer: "DHCP伺服器",
    ignoreInterface: "忽略此介面",
    ignoreTips: "不在此介面提供DHCP服務。",
    start: "開始",
    startTips: "網路位址的起始分配基底址。",
    customerNum: "顧客數",
    customerNumTips: "最大位址分配數量。",
    leaseTerm: "租期",
    leaseTermTips: "租用地址的到期時間，最短2分鐘（2m）。",
    DHCPOptions: "DHCP選項",
    DHCPOptionsTips:
      '設定DHCP的附加選項，例如設定 "6,114.114.114.114" 表示通告不同的 DNS 伺服器給客戶端。 ',
    DHCP: "DHCP客戶端",
    changeProtocol: "切換協定",
    confirmChange: "確定要切換協定？",
    hostname: "請求DHCP時傳送的主機名稱",
  },
  // 裝置配置-> 行動網絡
  mobile: {
    mobileNetwork: "行動網路",
  },
  // 裝置設定-> 防火牆
  firewall: {
    addNAt: "新建Source NAT",
    name: "名稱",
    protocal: "協議",
    protocalTips:
      "您也可以選擇「--自訂--」定義多個協議，在多個協議間需加空格。",
    sourceArea: "來源區域",
    sourceIp: "來源IP位址",
    targetArea: "目標區域",
    targetIp: "目標IP位址",
    SNATIp: "SNAT IP位址",
    SNATIpTips: "將符合流量的來源位址改寫成指定位址。",
    additonalParameters: "附加參數",
    additonalParametersTips: "傳遞到 iptables 的額外參數。小心使用！",
    all: "所有",
  },
  // 裝置配置-> 連接埠轉發
  port: {
    portForwards: "連接埠轉送",
    outerPort: "外部連接埠",
    innnerPort: "內部連接埠",
    enable: "開啟",
    addPortForwards: "新建連接埠轉送",
    other: "其他",
    addTips: "你有未填寫的選項，是否確認忽略並新增？",
    tips: "提示",
    innerPort: "內部連接埠",
  },
  // 設備配置-> smartlink
  smartlink: {
    general: "通用",
    modeConfiguration: "模式配置",
    enable: "啟用",
    uplink: "上行設備",
    downlink: "下行設備",
    connectConfiguraton: "連接配置",
    serialPort: "串列埠配置",
    interface: "介面",
    baudRate: "波特率",
    dataBits: "資料位元",
    stopBits: "停止位元",
    checkBits: "校驗位",
    flowControl: "流控",
    senior: "高級",
    enableSubcontracting: "啟用分包",
    subcontractingInterval: "分包間隔",
    subcontractingIntervalTips: "毫秒",
    subcontractingLength: "分包長度",
    subcontractingLengthTips: "位元組",
    name: "名稱",
    workingMode: "工作模式",
    targetAddress: "目標位址",
    status: "狀態",
    connected: "已連線",
    listening: "已偵聽",
    partialConnected: "部分連線",
    unknown: "未知",
    disconnect: "未連線",
    connectNumber: "連線數",
    protocal: "協議",
    listenPort: "監聽埠",
    serverAddress: "伺服器位址",
    serverTips: "位址:埠",
    serverError: "位址輸入有誤",
    platformName: "平台名稱",
    DTUNumber: "DTU編號",
    corporateLogo: "企業標誌",
    deviceType: "裝置類型",
    encyptionKey: "加密金鑰",
    GPSLogitude: "GPS經度",
    GPSLatitude: "GPS緯度",
    keyTime: "金鑰時間",
    deviceNumberPrefix: "裝置編號前綴",
    messagePrefix: "訊息前綴",
    messagePrefixTips: "以0x或0X開頭的標準十六進位串，最大4個位元組",
    messageLength: "訊息長度域位元組",
    messageLengthTips: "位元組",
    messageSequenceNumber: "訊息序號",
    deviceID: "裝置ID",
    deviceIDTips:
      "可支援ASCII和十六進位串。若為十六進位串，則必須是已0x或0X開頭的標準十六進位串，且最大長度為16位元組",
    CRCCheck: "CRC校驗",
    messageSuffix: "訊息字尾",
    deviceName: "裝置名稱",
    username: "使用者名稱",
    password: "密碼",
    subscribeTopics: "訂閱主題",
    reportingSubject: "上報主題",
    customerId: "客戶ID",
    MqttSurvivalCycel: "MQTT保活週期",
    enableHearbeat: "啟用心跳",
    heartbeatInterval: "心跳間隔",
    heartbeatIntervalTips: "秒",
    heartbeatContent: "心跳內容",
    heartbeatContentTips:
      "可支援ASCII和十六進位串。若為十六進位串，則必須是已0x或0X開頭的標準十六進位串，且最大長度為64位元組",
    debug: "調試",
    TCPSurvivalFreeTime: "TCP保活空閒時長",
    TCPSurvivalDetectionInterval: "TCP保活探測間隔",
    TCPSurvivalDetectionMax: "TCP保活探測最大次數",
    saveLogNumber: "保留日誌檔個數",
    logSize: "日誌檔案大小",
    download: "下載",
    log: "日誌檔",
    logPriority: "日誌優先權",
    pleaseChoose: "請選擇",
    TCPServer: "TCP服務端",
    TCPClient: "TCP客戶端",
    UDPServer: "UDP服務端",
    UDPClient: "UDP客戶端",
    RealCom: "實串口模式",
    MQTTClient: "MQTT客戶端",
    UART: "通用串口",
    PassThrough: "透傳模式",
    ModbusJSON: "Modbus JSON",
    ModbusRTU: "Modbus RTU",
    FourGDTU: "4G DTU", // 廣東質安
    SCTCOEM: "深圳建委協議", // 廣東質安
    Custom: "自訂",
    CYKJOEM: "超友科技", // 超友科技
    SHIERYEOEM: "中國二十冶集團", // 中國二十冶集團有限公司
    EHBOEM: "廣東E環保", // 廣東E環保
    msgError: "必須以0x或0X為前綴",
    nameError: "請輸入名稱",
    seconds: "秒",
    info: "訊息",
    notice: "注意",
    alarm: "警告",
    error: "錯誤",
    deadly: "致命",
    alert: "警戒",
    emergency: "緊急",
    modbusTCPMain: "Modbus TCP主站",
    modbusTCPFollow: "Modbus TCP從站",
    modbusRTUMain: "Modbus RTU主站",
    modbusRTUFollow: "Modbus RTU從站",
    slaveAddrees: "從站位址",
    slavePort: "從站埠",
    slaveID: "從站ID",
    slaveIDTips: "取值範圍: 0 ~ 255",
    responeTimeout: "回應逾時",
    ms: "毫秒",
    byteInterval: "位元組間隔",
    modbusDebug: "Modbus調試開關",
    localServer: "本地服務",
    subid: "sub裝置Id",
    AIOT: "阿里雲物聯網平台",
    UDSServer: "UDS伺服器",
    instanceId: "實例ID",
    productKey: "產品金鑰",
    deviceName: " 裝置名稱",
    deviceSecret: "裝置金鑰",
    uploadInter: "上報週期",
    snmpVersion: "SNMP版本",
    snmpGroupName: "SNMP讀寫分組名稱",
    udsServerPath: "伺服器位址",
    collection: '採集',
    resendError: '取值範圍: 0 ~ 5',
    ModbusASCIIMaster: 'Modbus ASCII主站',
    ModbusASCIIslave: 'Modbus ASCII從站',
    s7Client: 'S7 客戶端',
    rackNumber: '機架號',
    s7_slot: '槽位',
    CollectionCycle: '採集週期',
  },
  // 裝置配置 -> wifi
  wifi: {
    auto: "自動",
    CCMP: "強制 CCMP（AES）",
    TKIP: "強制 TKIP",
    CCMP_TKIP: "強制 TKIP 和 CCMP（AES）",
    static: "靜態位址",
  },
  // 設備配置-> 網路介面資訊
  network: {
    networkInfo: "網路介面基本資訊",
    interfaceName: "介面名",
    enableStatus: "啟用狀態",
    enabled: "已啟用",
    disable: "未啟用",
    ipAddress: "IP位址",
    subnetMask: "子網路遮罩",
    gateway: "網關位址",
    protocal: "協議",
    connectTime: "連線時長",
    DNSServer: "DNS服務",
    hops: "躍點",
    upstreamTraffic: "上行流量",
    downstreamTraffic: "下行流量",
    staticAddress: "靜態位址",
  },
  // 設備配置-> L2TP,pptp
  L2TP: {
    routeTips: "留空則不配置預設路由",
    LcpOneTips: "在指定數量的LCP回應故障後假定連結已斷開，0為忽略故障",
    LcpTwoTips: "定時發送 LCP 回應（秒），僅在結合了故障閾值時有效",
    assignedAddress: "手動指派地址",
    assignedAddressError: "指派位址格式不正確",
    ipTips: "本地IP:遠端IP",
  },

  // 請求
  request: {
    timeout: "請求逾時，請重試",
    smartlinkError: "請求逾時，請檢查設備！",
  },
  //批次配置
  firmware: {
    hFirstTask: "建立任務",
    equipment: "設備",
    multitasking: "任務名稱",
    VI_Task: "任務描述",
    AsyncOperationStatus: "任務完成狀態",
    createFile: "檔案名稱",
    timerfunction: "更新時間",
    Operation: "操作",
    configuration: "新增批次設定任務",
    Equipment: "可操作設備",
    file: "檔案",
    group1: "一級分組",
    group2: "二級分組",
    group3: "三級分組",
    cancel: "取消",
    Determine: "確定",
    $_blacklistedScalarArgsCallback: "建立任務成功",
    commands: "命令發送成功",
    connection: "遠端連線成功",
    define: "下載中",
    DownloadEventNotifier: "下載完成",
    upgrading: "升級中",
    upgrade_drush_command: "升級完成",
    username_last_used: "使用者名稱或密碼錯誤",
    tempfile: "404檔案不存在",
    Translators: "連線逾時，無法下載",
    zxid_add_name_field: "解析網域錯誤",
    DOWNLOADER_CLIENT_TLS_METHOD: "下載逾時",
    boolCheckPingURI: "MD5校驗失敗",
    upgrade_alter_tables: "升級失敗",
    keymaster_error_t: "升級失敗，未知錯誤",
    handle_remote_sigint: "遠端連線失敗",
    BAG_FILTER_EQUIPMENT: "設備已下線，稍後重試",
    m_upgradeThread: "升級套件校驗失敗",
    TestDelete: "刪除成功",
    intbdb_delete: "刪除失敗",
    CompositeTask: "刪除任務",
    MissionAccomplished: "完成任務",
    Ongoing: "正在進行",
    search1: "輸入任務名稱",
    search2: "輸入任務說明",
    search3: "輸入任務完成狀態",
    search4: "輸入檔名",
    search5: "輸入更新時間",
  },
  ReportManagement: {
    Rates: "線上比率",
    Units: "單位",
    signals: "訊號值",
    number: "設備數",
    Version: "軟體版本",
    datatype: "暫無資料",
    setPrompt: "提示",
    Determine: "確定",
  },
  //統計日期元件
  DateSelect: {
    StatisticType: "統計類型",
    year: "年",
    month: "月份",
    data: "日期",
    hour: "小時",
    minute: "分鐘",
    Group1: "一級",
    Group2: "二級",
    Group3: "三級",
    Device: "設備",
    luaall_c: "全部",
    Statistical: "統計",
    PleaseChoose: "請選擇",
    message1: "請選擇分組",
    message2: "請選擇設備",
    message3: "請選擇年份",
    message4: "請選擇月份",
    message5: "請選擇日期",
    message6: "請選擇小時",
    singleMonth: "月",
    singleDate: "號",
    singlehour: "時",
    singleminute: "分",
    st: "號碼",
    rd: "號碼",
    nd: "號碼",
    th: "號",
  },
  // 月份中文
  month: {
    "1": "1月",
    "2": "2月",
    "3": "3月",
    "4": "4月",
    "5": "5月",
    "6": "6月",
    "7": "7月",
    "8": "8月",
    "9": "9月",
    "10": "10月",
    "11": "11月",
    "12": "12月",
  },
  //韌體管理
  softwarepackage: {
    Software: "軟體名稱",
    Version: "軟體版本",
    types: "軟體型別",
    SoftwareSize: "軟體大小(KB)",
    adminhelpuploadusers: "上傳使用者",
    m_UploadOMeter: "上傳時間",
    SynchronizationStatus: "同步狀態",
    Operation: "操作",
    Add: "新增",
    addVarCopy: "新增套件",
    add_action: "點擊上傳",
    file_name: "檔案格式必須為.tar.gz",
    uploaders: "上傳",
    Modify: "修改包",
    FirmwareAuthority: "韌體權限",
    VisibleUser: "可見使用者",
    DesignatedCustomer: "指定客戶",
    AllUsers: "所有使用者",
    SystemAdministrator: "系統管理者",
    Cancel: "取消",
    Confirm: "確定",
    SuccessfullyModified: "修改成功",
    onCallModifying: "修改失敗",
    Pleaseselectacustomer: "請選擇指定客戶",
    PLEASE: "請選擇",
    justUploaded: "上傳成功",
    successfully: "上傳失敗",
    TestDelete: "刪除成功",
    bdb_delete: "刪除失敗",
    remove_pkg: "移除軟體包",
    search1: "請輸入軟體名稱",
    search2: "請輸入軟體版本",
    search3: "請輸入軟體類型",
    search4: "請輸入軟體大小",
    search5: "請輸入上傳使用者",
    search6: "請輸入上傳時間",
    search7: "請輸入同步狀態",
    UpgradePackage: "升級包",
    PatchPackage: "補丁包",
    OrdinaryFile: "普通檔案",
    Synced: "已同步",
    NotSynchronized: "未同步",
  },
  //軟體任務
  upgrade: {
    equipment: "設備",
    FutureTask: "任務名稱",
    TaskStatus: "任務描述",
    addDistributionPackages: "新增升級任務",
    completion: "任務完成狀態",
    createFile: "檔案名稱",
    UPDATE_TO: "更新時間",
    Operation: "操作",
    hFirstTask: "建立任務",
    group1: "一級分組",
    group2: "二級分組",
    group3: "三級分組",
    adding: "新增升級任務",
    Equipment: "可操作設備",
    file: "檔案",
    upgrades: "保留配置升級",
    Dont: "不保留",
    cancel: "取消",
    Determine: "確定",
    $_blacklistedScalarArgsCallback: "建立任務成功",
    commands: "命令發送成功",
    connection: "遠端連線成功",
    define: "下載中",
    DownloadEventNotifier: "下載完成",
    upgrading: "升級中",
    upgrade_drush_command: "升級完成",
    username_last_used: "使用者名稱或密碼錯誤",
    tempfile: "404檔案不存在",
    Translators: "連線逾時，無法下載",
    zxid_add_name_field: "解析網域錯誤",
    DOWNLOADER_CLIENT_TLS_METHOD: "下載逾時",
    boolCheckPingURI: "MD5校驗失敗",
    upgrade_alter_tables: "升級失敗,檔案格式錯誤",
    keymaster_error_t: "升級失敗，未知錯誤",
    handle_remote_sigint: "遠端連線失敗",
    BAG_FILTER_EQUIPMENT: "設備已下線，稍後重試",
    TestDelete: "刪除成功",
    bdb_delete: "刪除失敗",
    CompositeTask: "刪除任務",
    search1: "輸入任務名稱",
    search2: "輸入任務說明",
    search3: "輸入任務完成狀態",
    search4: "輸入檔名",
    search5: "輸入更新時間",
    KeepConfiguration: "保留設定",
    Keep: "保留",
    TaskType: "任務類型",
    UpgradeTask: "升級任務",
    PatchTask: "補丁任務",
    StartingTime: "開始時間",
    MissionDetails: "任務說明",
    FileServer: "檔案伺服器",
    MissionAccomplished: "完成任務",
    Ongoing: "正在進行",
    SerialNumber: "序號",
    BackupServer: "備份伺服器",
    DefaultServer: "預設伺服器",
    PrimaryServer: "主伺服器",
    checkSerialNumber: "請檢查序號是否有誤",
    selectDevice: "請選擇裝置",
    normalTask: "普通任務",
    Version_NOT_SURPPORT: "版本不支持，請升級設備到最新版本",
    unknownError: "未知錯誤",
  },
  //任務組件
  taskDialog: {
    FutureTask: "任務名稱",
    TaskStatus: "任務描述",
    completion: "任務完成狀態",
    group1: "一級分組",
    group2: "二級分組",
    group3: "三級分組",
    Equipment: "可操作設備",
    cancel: "取消",
    Determine: "確定",
    please: "請選擇裝置",
    File_Upload_Upgrader: "請選擇升級檔案",
    Dispatched: "操作成功",
    operation: "操作失敗",
    file: "檔案",
    provide: "請輸入任務名稱",
    reassign_task_to: "請輸入任務描述",
    fileServer: "檔案伺服器",
    TaskType: "任務類型",
    fileType: "檔案類型",
    fileSize: "檔案大小",
    deviceList: "裝置待選清單",
    deviceChecked: "裝置選取清單",
    confirmCreate: "確認建立任務",
    upgradeFile: "升級檔案",
    filename: "檔名",
    toUpgrade: "待升級清單",
    filter: "輸入序號進行過濾",
  },
  //權限管理
  Authoritymanagement: {
    Add: "新增",
    Character: "角色名稱",
    describe: "描述",
    statevoid: "狀態",
    Creator: "創作者",
    belonging: "歸屬客戶",
    Creation: "建立時間",
    Operation: "操作",
    hidden: "隱藏",
    show: "顯示",
    DEFINED_RIGHTS: "權限管理",
    ANSI_PADDING: "新增角色",
    Description: "角色描述",
    cancel: "取消",
    Determine: "確定",
    mandatory: "權限指派",
    functionname: "功能名稱",
    m_pr_modifyS: "修改成功",
    onCallModifying: "修改失敗",
    deleteDir: "刪除成功",
    intbdb_delete: "刪除失敗",
    Authorization: "請選擇角色權限",
    localSuccess: "新增成功",
    NewNextNotifyDT: "新增失敗",
    BoxapiJSONOperation: "操作失敗",
    User_Role_Editor: "範本角色無法修改",
    addinganewrole: "刪除角色",
    normal: "正常",
    Executing: "請輸入新增的角色名稱",
    l_vinformupdate: "請輸入新增的角色描述",
    search1: "輸入角色名稱",
    search2: "輸入描述",
    search3: "輸入狀態分類",
    search4: "輸入建立者名稱",
    search5: "輸入歸屬客戶名稱",
    search6: "輸入建立時間",
    deviceManagement: "裝置管理"
    // SuperAdministratorRoleTemplate:'超級管理員角色模板',
    // CustomerAdministratorRoleTemplate:'客戶管理員角色範本',
    // OrdinaryUserRoleTemplate:'普通使用者角色範本',
    // RoleTemplate:'角色模板'
  },
  //客戶管理
  customermanagement: {
    Add: "新增",
    customerName: "客戶名稱",
    Customer: "客戶ID",
    Admin: "管理者",
    Contact: "聯絡人",
    phone: "聯絡電話",
    Email: "信箱",
    detailed: "詳細地址",
    services: "服務類型",
    Operation: "操作",
    userDisplay: "使用者角色",
    HomeThis: "首頁",
    ADDRESS: "位址",
    cancel: "取消",
    Determine: "確定",
    news: "新增客戶",
    CustomerAttributes: "修改客戶資訊",
    message1: "新增成功",
    message2: "權限不足，新增失敗",
    message3: "使用者已存在，新增失敗",
    message4: "客戶已存在，新增失敗",
    message5: "郵箱已被註冊，新增失敗",
    message6: "手機號碼已註冊，新增失敗",
    message7: "名稱重複，新增失敗",
    message8: "新增失敗",
    message9: "刪除成功",
    message10: "刪除失敗,該客戶不能被刪除",
    message11: "刪除失敗",
    message12: "修改成功",
    message13: "修改失敗",
    errmessage1: "客戶名稱為必填項",
    errmessage2: "請選擇使用者角色",
    Mage_Customer: "刪除客戶",
    Mandatory: "必填",
    specifiedwill: "必選",
    Optional: "選填",
    ServiceClient: "標準服務",
    PrintCore: "遠端列印",
    search1: "客戶名稱搜尋",
    search2: "客戶ID搜尋",
    search3: "管理者搜尋",
    search4: "聯絡人搜尋",
    search5: "聯絡電話",
    search6: "信箱",
    search7: "詳細地址",
    search8: "服務類型",
    inputName: "請輸入客戶名稱",
    selectRole: "請選擇使用者角色",
    notEdit: "未作修改！",
    imgFormate: "上傳頭像圖片只能是 JPG或PNG 格式!",
    imgSize: "上傳頭像圖片大小不能超過 2MB!",
    LogoFormate: "上傳Logo圖片只能是 JPG或PBG 格式!",
    LogoSize: "上傳Logo圖片大小不能超過 2MB!",
    StandardService: "標準服務",
    RemotePrint: "遠端列印",
    copyrightInformation: "版權資訊",
    template: `模板："Copyright @ 2019-2022 英文簡稱 All Rights Reserved 公司名稱 版權所有 備案號"`
  },
  //使用者管理
  usercontrol: {
    Add: "新增",
    UserGroup: "使用者名稱",
    FILE_REAL_H: "真實姓名",
    belonging: "歸屬客戶",
    bituser: "使用者類型",
    phone: "聯絡電話",
    email: "信箱",
    user_admin: "使用者角色",
    recently: "最近登入",
    Operation: "操作",
    detailed: "詳細資料",
    userinfo: "新增使用者資訊",
    userDisplay: "使用者密碼",
    NICKNAME_RE: "使用者暱稱",
    Gender: "性別",
    Male: "男",
    Female: "女",
    users_grid: "使用者身分",
    socialize: "QQ/微信",
    email: "信箱",
    address: "地址",
    notesData: "備註",
    cancel: "取消",
    Determine: "確定",
    USER_UPDATE: "使用者詳情",
    user_exists: "修改使用者",
    change_password: "修改密碼",
    New_Object: "新密碼",
    changePassword: "確認新密碼",
    errmessage1: "使用者名稱由任意數字、字串、底線組成",
    errmessage2: "使用者密碼由任意數字、字串、底線組成，必須超過6位小於16位",
    errmessage3: "使用者權限為必選",
    errmessage4: "使用者身分為必選項",
    errmessage5: "請輸入正確的手機號碼",
    errmessage6: "兩次密碼輸入不一致",
    errmessage7: "使用者密碼由任意數字、字串、底線組成，必須超過6位小於16位",
    usertype1: "普通使用者",
    usertype2: "客戶管理員",
    usertype3: "系統管理員",
    usertype4: "系統超級管理員",
    message1: "新增成功",
    message2: "此信箱已註冊",
    message3: "此手機號碼已註冊",
    message4: "此使用者名稱已註冊",
    message5: "新增失敗",
    message6: "刪除成功",
    message7: "無法刪除系統超級管理員",
    message8: "刪除失敗",
    message9: "修改成功",
    message10: "修改失敗",
    user_page_q_exports: "刪除使用者",
    Mandatory: "必填",
    Optional: "選填",
    choose: "必選",
    search1: "使用者名稱",
    search2: "真名",
    search3: "歸屬客戶",
    search4: "使用者類型",
    search5: "手機",
    search6: "信箱",
    search7: "使用者角色",
    search8: "最近登入",
    alarmSetting: "警報設定",
    monitorSetting: "雲端監測功能",
    alarmTips: "確認開啟設備下線警報提醒？",
    monitorTips: "確認開啟雲監測功能？",
    monitorCloseTips: "確認關閉雲監測功能？",
    alarmCloseTips: "確認關閉設備下線警報提醒？",
    selectRoleTips: "請選擇使用者角色",
    selectCustomerTips: "請選擇使用者身分",
    selectTelTips: "請填寫聯絡電話",
    selectEmailTips: "請填寫信箱",
  },
  // 參數管理
  parameter: {
    name: "參數名稱",
    description: "參數描述",
    value: "參數值",
    time: "新增/修改時間",
    chineseName: "參數中文名稱重複",
    englishName: "參數英文名重複",
  },
  //刪除彈出框
  DeleteBox: {
    prompt: "提示",
    Tetx: "此操作將永久刪除該資料, 是否繼續?",
    confirmButtonText: "確定",
    cancelButtonText: "取消",
  },
  // n2n
  n2n: {
    serverName: "服務名稱",
    version: "軟體版本",
    port: "連接埠號碼",
    totalGroups: "分組總數",
    totaldevices: "設備總數",
    createTime: "建立時間",
    groupManagement: "n2n分組管理",
    groupInfo: "分組資訊",
    groupName: "分組名",
    customer: "歸屬客戶",
    username: "遠端帳號",
    password: "遠端密碼",
    ip: "遠端IP",
    remotePort: "遠端埠",
    deivceNumber: "設備數目",
    migrate: "遷移分組所屬服務",
    target: "目標服務",
    original: "原服務",
    originalN2N: "原N2N",
    targetN2N: "目標N2N",
    confirmTips: "此操作將修改該分組n2n服務, 是否繼續?",
    groupComfirm: "此操作將修改該n2n下的所有分組, 是否繼續?",
    inputEmpty: "不能為空",
    versionEmpty: "n2n版本不能為空",
    versionInt: "n2n版本只能為整數",
    portRang: "請輸入9001~50000的連接埠",
    serverEmpty: "服務名稱不能為空",
    // 服務地址不可以為空
    serverAddressEmpty: "服務位址不可以為空",
    portRepeat: "連接埠號重複",
    PresenceDevice: "n2n下存在設備",
    PresenceGroup: "n2n下存在分組",
    deleteN2n:
      "刪除N2N服務，將導致改服務下所有設備的遠端功能失效，確定要刪除嗎？",
    serverAddress: "服務位址",
    groupAutomaticDistribution: "分組自動散佈",
    // 輸入分組名稱
    inputGroupName: "遠端帳號",
    // 分組提示
    groupTips: "勾選此選項後，建立分組時，該服務會自動指派到新分組",
    queryTeam: "(查詢帳號所屬服務)"
  },
  xlsx: {
    export: "導出",
  },
  // 下掛裝置
  HangingDevice: {
    alias: "名稱",
    vendor: "供應商",
    type: "型號",
    status: "狀態",
    lastts: "最後列印時間",
    did: "伺服器did",
    dsn: "伺服器序號",
    printeMethod: "列印方式",
    port: "端口",
    serialNumber: "序號",
    edit: "編輯",
    offline: "離線",
    online: "線上",
    Description: "描述",
    successNumber: "列印成功數",
    failNumber: "列印失敗數",
    totalNumber: "列印總數",
    finalTime: "最後列印時間",
  },
  // 列印驅動程式管理
  PrinterDriver: {
    printDrive: "列印驅動位址",
    printType: "型號",
    printDriveSearch: "根據驅動位址搜尋",
    printTypeSearch: "根據型號搜尋",
    driveSign: "驅動標誌",
    common: "普通",
    special: "特殊",
    debugFlag: "調試標誌",
    notDebugging: "未調試",
    debuggingThrough: "調試通過",
    debuggingFailed: "調試未通過",
    printTypeInput: "請輸入印表機型號",
    driveSignSelect: "請選擇驅動標誌",
    debugFlagSelect: "請選擇調試標誌",
    printDriveInput: "請輸入印表機驅動位址",
    remark: "備註",
    remarkInput: "請輸入備註",
  },
  /**
  * 雲監測
  */
  // 警報通知
  Confirm: {
    SuccessfullyDelete: "刪除成功",
    DeleteFailed: "刪除失敗，請重試！",
    SuccessfullyAdd: "新增成功",
    AddFailed: "新增失敗，請重試",
    SuccessfullyEdit: "編輯成功",
    EditFailed: "編輯失敗，請重試",
  },
  Input: {
    placeholder: "請選擇",
    inputPlaceholder: "請輸入",
  },
  // 監控大螢幕
  Monitor: {
    MonitorScreen: "監控大螢幕",
    systemOverview: "系統總覽",
    deviceConfiguration: "裝置組態",
    deviceOverview: "裝置概況",
    deviceTotalNumber: "裝置總數",
    totalOffline: "離線總數",
    totalOnline: "線上總數",
    deviceList: "裝置清單",
    deviceSearch: "SN/名稱",
    disconnected: "未連線",
    connected: "已連線",
    alarmStatistics: "警報統計",
    todayTotalNumber: "今日警報總數",
    todayProcessedNumber: "今日已處理總數",
    todayUnprocessedNumber: "今日未處理總數",
    alarmInfo: "警報訊息",
    alarmHandling: "警報處理",
    alarmStartTime: "警報開始時間",
    alarmEndTime: "警報結束時間",
    alarmResult: "警報結果",
    Unprocessed: "未處理",
    Processed: "已處理",
    ProcessingDescription: "處理描述",
    device: "裝置",
    terminal: "終端",
    variable: "變數",
    content: "內容",
    deviceInfo: "裝置資訊",
    historyData: "歷史資料",
    historyAlarm: "歷史警報",
    deviceName: "裝置名稱",
    deviceAddress: "裝置位址",
    project: "所屬項目",
    terminalName: "終端名稱",
    setVariable: "設定變數",
    to: "至",
    search: "查詢",
    export: "導出",
    addedVariable: "已新增變數",
    realTimeAlarm: "即時警報資料",
    realTimeMonitoring: "即時監控",
    terminalRealTimeData: "即時終端資料",
    pleaseTerminal: "請選擇終端",
    pleaseVariable: "請選擇變數",
    Pleasetime: "請選擇時間",
    Open: "開",
    Close: "關",
    collectionTime: "採集時間",
    pleaseModifyValu: "請輸入修改值",
    loading: "載入中...",
    setValue: "修改值",
    noData: "沒有找到資料。請檢查您的搜尋條件！",
  },
  // 快速存取
  FastAccess: {
    addProject: "新增項目",
    addDevice: "新增設備",
    addTerminal: "新增終端",
    addTemplate: "採集配置",
    startCollecting: "啟動採集",
    projectName: "專案名稱",
    deviceSn: "裝置序號",
    terminalName: "終端名稱",
    projectTips1: "您的專案為",
    projectTips2: "可在項目清單上查看詳細資料",
    deviceTips1: "裝置為",
    deviceTips2: "可在裝置清單查看詳細資料",
    terminalTips1: "終端為",
    terminalTips2: "可在終端機清單查看詳細資料",
    continueAdd: "繼續新增",
    successTips: "您已操作成功！",
    BelogingUser: "所屬使用者",
    ownCustomer: "所屬客戶",
    projectType: "專案類別",
    selectProject: "選擇已有項目",
    genericType: "通用型別",
    pleaseName: "請輸入名稱",
    pleasecustomer: "請選擇客戶",
    pleaseProject: "請選擇專案所屬客戶",
    firstGrouping: "一級分組：",
    next: "下一步",
    backNewProject: "返回新建專案",
    levelGrouping: "專案一級分組：",
    secondaryGrouping: "專案二級分組：",
    previous: "上一步",
    NewTemplate: "新採集範本",
    IssueCollection: "下發採集",
    ConfirmAdd: "確認新增",
    pleaseTname: "請輸入範本名稱",
    selectedCollection: "請輸入選擇擷取方式",
    collectionTemplate: "已有採集範本",
    warning1: "尚存在變數未下發採集指令，請先下發採集指令！",
    Failedtoadddevice: "裝置新增失敗",
    tryagain: "請求失敗，請重試",
    pleasechooseanother: "此裝置未連接，請重新選擇裝置！",
    Failedtoeditgroup: "編輯分組失敗",
    Failedtoaddgroup: "新增分組失敗",
    Commandissuedsuccessfully: "指令下發成功",
    variablesfirst: "請先加入變數!",
    variablelist: "取得變數清單失敗!",
    configurationfailed: "終端機串列設定失敗！",
    terminalcommands: "終端指令下發失敗！",
    Failedtoaddterminal: "新增終端機失敗"
  },
  // 變數列表
  variableList: {
    seriableNumber: "序號",
    name: "變數名",
    unit: "單位",
    registerMode: "暫存器方式",
    registerAddress: "暫存器起始位址",
    dataType: "資料型別",
    byteOrder: "字節序",
    triggerType: "上報類型",
    triggerPeriod: "回報週期",
    calculationFactor: "計算因子",
    decimalPrecision: "小數精度",
    setThreshold: "設定閾值",
    minimum: '最小值',
    maximum: '最大值',
    value: '值'
  },
  // 裝置管理
  devicesManagement: {
    FastAccess: "快速存取",
    ProjectGroup: "項目清單",
    TerminalList: "終端機清單",
    CollectConfigurate: "擷取設定",
    EditCollection: "新增變數",
    AddDevice: "新增設備",
    AddTerminal: "新增終端機",
    deviceList: "裝置清單",
    variableList: "變數列表",
    addATemplate: "新增模板",
    editATemplate: "修改模板",
    Noprojectgroups: "未選擇項目分組和設備！",
    Nodeviceselected: "未選擇設備！",
    Noprojectgroup: "未選擇項目分組！",
    Addedsuccessfully: "新增成功！",
    webssh: "遠端終端"
  },
  // 項目列表
  projectList: {
    name: "名稱",
    projectName: "專案名稱",
    BelogingCustomer: "歸屬客戶",
    creator: "創建者",
    createTime: "建立時間",
    AddProject: "新增項目",
    EditProject: "編輯專案",
    FirstProjectGroup: "一級分組",
    BelogingUser: "所屬使用者",
    projectType: "專案類型",
    generictype: '一般型別',
    confirmdeletion: '確認刪除?',
    cannotbedeleted: "專案分組存在設備，無法刪除！"
  },
  // 警報管理類
  alarmManagement: {
    alarmManagement: "警報管理",
    AlarmNotice: "警報通知",
    AlarmContact: "警報聯絡人",
    AlarmList: "警報記錄",
    viewterminal: "查看終端"
  },
  // 警報通知
  alarmNotice: {
    device: "裝置",
    terminal: "終端",
    variable: "變數",
    alarmContent: "警報內容",
    alarmStartTime: "警報開始時間",
    alarmEndTime: "警報結束時間",
    triggering: "觸發條件",
    enable: "已啟用",
    disabled: "未啟用",
    add: "新增",
    serialNumber: "序號",
    eventName: "事件名稱",
    way: "方式",
    information1: "通知訊息(警報)",
    information2: "通知訊息(恢復)",
    tsn: "終端SN（名稱）",
    pushMechanism: '推播機制',
    once: "一次",
    repeatedly: "多次",
    state: "狀態",
    AlarmContact: "警報聯絡人",
    operate: "操作",
    EditingAlarm: "編輯警報通知",
    Addalarm: '新增警報通知',
    email: "信箱",
    Alarmterminal: '警報終端',
    timeInterval: "時間間隔",
    minute: "分鐘",
    msg1: "請輸入警報通知名稱",
    msg2: "請選擇警報方式",
    msg3: "請選擇警報終端和警報聯絡人！",
    msg4: "請選擇警報終端機！",
    msg5: '請選擇報警聯絡人！ ',
    msg6: '修改成功！ ',
    msg7: '修改失敗，請重試！ ',
    msg8: '新增成功！ ',
    msg9: '新增失敗，請重試！ ',
    pleaseChoose: '請選擇',
    Alarmoperate: '警報操作',
    numberValue: '數值',
    Newcontact: '新聯絡人'
  },
  // 統計報表
  statictics: {
    HistoryRecords: "歷史記錄",
    DevicesStatus: "裝置上上下線",
  },
  Button: {
    Add: "新增",
    submit: "提交",
    confirm: "確定",
    cancel: "取消",
    edit: "編輯",
    delete: "刪除",
    operation: "操作",
    tips: "提示",
    isDelete: "確定刪除？",
    successDelete: "刪除成功！",
    failDelete: "刪除失敗！",
    successEdit: "修改成功！",
    failEdit: "修改失敗",
    successSetting: "設定成功！",
    failSetting: "設定失敗",
    successOperation: "操作成功！",
    failOperation: "操作失敗，請重試！",
    successConfiguration: "配置成功",
    failConfiguration: "配置失敗",
    successAdd: "新增成功！",
    failAdd: "新增失敗！",
    refresh: '重新整理伺服器位址',
  },
  // 頂部導航
  navTab: {
    devicesManagement: "裝置管理",
    monitorCloud: "雲端監測",
  },
  //切卡記錄
  switchCrad: {
    switchCradRecord: "切卡記錄",
    startDate: "開始日期",
    endDate: "結束日期",
    Inquire: "查詢",
    serialNumber: "序號",
    OperatorFront: "操作員(前)",
    ViewChekaRecords: "查看切卡記錄",
    ICCIDFront: "ICCID(前)",
    SignalFront: "訊號(前)",
    operatorRear: "操作員(後)",
    ICCIDRear: "ICCID(後)",
    SignalRear: "訊號(後)",
    ChekaTime: "切卡時間",
    Cancel: "取 消",
  },
  //上線記錄
  onAndOf: {
    OnlineAndOfflineRecords: "上下線記錄",
    time: "時間",
    type: "型別",
    offline: "下線",
    online: "上線",
    all: "全部",
    GetFailed: "取得失敗!",
    repair: "裝置修復",
  },
  //變數列表
  varlist: {
    terminalType: "終端機類型",
    ReturnToTerminalList: "返回終端清單",
    Inquire: "查詢",
    PleaseEnterVariableName: "請輸入變數名稱",
    terminalName: "終端名稱",
    aName: "請輸入名稱",
    varNmae: "變數名稱",
    Selectendian: "選擇字節序",
    Choosereporttype: "選擇回報類型",
    controltype: "控制類型",
    precision: "精度",
    Selectdatatype: "選擇資料類型",
    maximumvalue: "請輸入最大值",
    minimumValue: '請輸入最小值',
    confirm1: "此操作將永久刪除該資料, 是否繼續?",
    variabletype: "該變數型別無法設定閾值!",
    sendcollection: "下發採集失敗!",
    ActionThresholdFailed: "操作閾值失敗!",
    viewterminal: "查看終端",
  },
  //終端機列表
  terminalList: {
    add: '新增',
    name: '名稱',
    serialNumber: '序號',
    templateName: '模板名稱',
    protocol: '協議',
    describe: '描述',
    Edittheterminaldevice: "編輯終端設備",
    Addaterminaldevice: "新增終端設備",
    Fillintheterminalinformation: "填寫終端資訊",
    Collectionconfigurationtemplate: "擷取設定範本",
    Templatecategory: "範本類別",
    Protocol: "協議",
    Equipment: "所屬設備",
    Name: "名稱",
    SlaveID: "從站ID",
    Valuerange: "取值範圍：0~",
    Slaveaddress: "從站位址",
    Port: "連接埠",
    SerialportNo: "裝置串列口號",
    Pleaseselecttheequipmentfirst: "請先選擇所屬設備",
    Configureserialportinformation: "設定串列埠資訊",
    Cancel: "取消",
    Confirm: "確認",
    //
    Successfullymodified: "修改成功!",
    Successfullyadded: "新增成功!",
    Requestfailed: '請求失敗',
    Serialportconfigurationfailed: '串列埠配置失敗！ ',
    Failedtoissuethecommand: "指令下發失敗！",
    Collectionfailed: "終端機資訊擷取失敗，請確認終端基本資訊參數！",
    Collectionrequesterror: "終端資訊擷取請求錯誤！",
    Modificationfailed: '修改失敗，請重試！ ',
    Addingfailed: '新增失敗，請重試！ ',
    Notselected: "未選擇所屬裝置",
    Incorrectfilling: "終端資訊未正確填寫！",
    form1: "請選擇擷取設定範本",
    form2: "請選擇所屬設備",
    form3: '請輸入從站ID',
    form4: "不可以是負數",
    form5: "從站ID取值範圍：0~",
    form6: "請輸入從站位址",
    form7: "從站位址輸入錯誤",
    form8: "連接埠號碼錯誤",
    form9: "請輸入終端名稱",
    form10: "無資料",
    form11: "請選擇終端協定",
    form12: "連接埠號碼不符合",
    Basicinformation: "終端設備基本資訊",
    Protocolinformation: '協定資訊',
    TerminalDetails: "終端設備詳情",
    details: "詳情",
    returntodevicelist: "返回裝置清單",
    Terminalinformation: "終端資訊擷取出錯，請檢查終端資訊參數！",
    collectionrequesterror: '終端資訊擷取請求出錯！ ',
    hiddenTerminal: "隱藏終端",
    nohiddenTerminal: "非隱藏終端",
    terminalNumber: "終端編號",
    monitoringLocation: "監控地點",
    accessTime: "接入時間",
    showDetail: "是否隱藏此終端",
    tip: "提示",
    copySuccess: "複製成功",
    copyFail: "複製失敗",
    deleteDetail: "是否刪除此終端",
    refresh: '刷新',
    plsupdate: '此服務不支援自動刷新，如需更新資料請手動點選刷新按鈕',
    index: '序號',
    ip: "IP位址",
    mac: 'MAC位址',
    networkInterface: '網路介面',
    operate: '操作',
    directAccess: '直接存取',
    configAccess: '設定存取',
    connectTips: '連線提示',
    stopClose: '請不要關閉此窗口，關閉後視為斷開連接!',
    portToAccess: '要存取的連接埠',
    urlToAccess: '要存取的路徑',
    EstablishConnection: '建立連結',
  },
  //擷取配置
  collect: {
    templateName: '模板名稱',
    TemplateType: '模板類型',
    Updateddate: '更新日期',
    TemplateInformation: "範本資訊",
    save: "儲存",
    variableInformation: "變數資訊",
    PleaseSave: "新增變數前請先儲存範本資訊",
    IssueCollection: "下發採集",
    Cancel: "取消",
    describe: "描述",
    addVariable: "新增變數",
    serialNumber: '序號',
    variableName: "變數名",
    unit: "單位",
    registertype: "暫存器類型",
    startaddress: '暫存器起始位址',
    typeofdata: '資料類型',
    endian: "字節序",
    Reportingtype: '上報類型',
    Reportingcycle: '上報週期',
    second: '秒',
    calculationfactor: '計算因子',
    decimalprecision: '小數精度',
    IOcontrollertype: 'IO控制器類型',
    interfacenumber: '介面號碼',
    functiontype: '功能類型',
    operate: '操作',
    msg1: '此操作將永久刪除該資料, 是否繼續?',
    msg2: '提示',
    msg3: '確認',
    msg4: '刪除成功！ ',
    msg5: '指令下發成功！ ',
    msg6: '指令下發失敗，請重試！ ',
    msg7: '該變數正在執行採集任務，請先停止再刪除！ ',
    msg11: "改模板有終端機正在使用，不可以刪除!",
    msg8: '刪除失敗，請重試！ ',
    msg9: '請選擇採集範本！ ',
    msg10: "表單資料未正確填寫！",
    setalarm: "設定警報",
    Callthepolice: "警報：",
    Triggeringconditions: "觸發條件：",
    PleasevalueA: "請輸入數值A",
    PleasevalueB: "請輸入數值B",
    Alarmpushcontent: "警報推送內容：",
    Restorepushcontent: "恢復推播內容：",
    SwitchOFF: "開關OFF",
    switchON: "開關ON",
    valuelessA: '數值小於A',
    valuegreaterB: "數值大於B",
    ValuegreaterAlessB: "數值大於A且小於B",
    ValuelessAgreaterB: '數值小於A或數值大於B',
    valueisequaltoA: "數值等於A",
    Failedtoobtain: "警報規則取得失敗！",
    Setupsucceeded: "設定成功！",
    Setupfailed: "設定失敗，請重試",
    Savefailed: "儲存失敗，請重試！",
    pleaseTcontent: '請輸入警報推送內容'
  },
  //編輯變數
  editVar: {
    Editvariables: '編輯變數',
    addvariable: '新增變數',
    type: '類型',
    rawtype: '讀寫類型',
    variableunit: '變數單位',
    inputrange: '輸入範圍：0~65535',
    typedata: '資料型態',
    reportingperiod: '請輸入上報週期',
    calculationfactor: '請輸入計算因子',
    decimalprecision: '小數精度',
    msg1: '請輸入計算因子，且不能為0',
    msg2: '計算因子不能為0',
    msg3: "計算因子只可以是數字",
    msg4: '暫存器位址錯誤，輸入範圍：0~65535',
    msg5: '請選擇功能類型',
    msg6: '請輸入變數名稱',
    msg7: '請選擇暫存器類型',
    msg8: '請選擇變數類型',
    msg9: '請輸入變數單位',
    msg10: '範圍只可以0~65535之間',
    msg11: '請輸入變數小數精確度',
    msg12: '請選擇資料類型',
    msg13: '請選擇字節序',
    msg14: '請選擇上報類型',
    msg15: '請輸入上報週期',
    msg16: '請輸入介面號碼',
    msg30: "請輸入正確的sid",
    relay1: '繼電器1',
    relay2: '繼電器2',
    bool: "布林型（bool）",
    readandwrite: '讀寫',
    read: '唯讀',
    msg17: '修改成功！ ',
    msg18: '修改失敗，請重試！ ',
    msg19: '新增成功！ ',
    msg20: '新增失敗，請重試！ ',
    msg21: '輸入自訂的值',
    msg22: '提示',
    msg23: '確定',
    msg24: '取消',
    msg25: '只可以是數字',
    msg26: '自訂',
    msg27: '取消輸入',
    msg28: "改變量無法修改值",
    Pleaseentertheunit: "請輸入單位",
    msg28: "單位長度過長",
    msg29: "單位不能為空",
    pleaseEnterAValidValue: "請輸入有效值",
    pleaseEnterInt32: "請輸入int32型別的值",
    pleaseEnterUint32: "請輸入uint32型別的值",
  },
  smartcat: {

  },
  openvpn: {
    name: "名稱",
    recipe: "模式",
    enabled: "啟用",
    open: "開啟",
    close: "關閉",
    port: "端口",
    proto: "協議",
    status: "已運行的",
    yes: "是",
    no: "否",
    constatus: "狀態",
    start_stop: "啟動/停止",
    start: "啟動",
    stop: "停止",
    operate: "操作",
    edit: "編輯",
    noConnect: "未連線",
    connecting: "連線中",
    actionOk: "啟動成功",
    stopOk: "暫停成功",
    configuration: "編輯",
    tips1: "設定輸出冗餘等級",
    tips2: "連接埠 TCP/UDP 連接埠 # 同時針對本機和遠端",
    tips3: "使 tun 裝置相容 IPv6",
    tips4: "使用裝置類型",
    tips5: "server 設定伺服器模式",
    tips6: "配置伺服器橋接",
    tips7: "nobind 不綁定本地地址和連接埠",
    tips8: "加密資料包",
    tips9: "使用快速 LZO 壓縮",
    tips10: "在 2.4+ 版本上使用壓縮選項",
    tips11: "在服務設定模式下簡化 Helper 指令 --ping 和 --ping-restart 的表達式",
    tips12: "採用協議",
    tips13: "設定客戶端模式",
    tips14: "遠端主機名稱或 ip 位址",
    tips15: "認證方式，預設使用 ca 憑證認證",
    tips16: "以使用者名稱/密碼的方式進行驗證",
    tips17: "選擇檔案",
    tips18: "secret 允許靜態金鑰加密模式",
    tips19: "cert PEM格式本地憑證",
    tips20: "PKCS#12 檔案所包含的金鑰",
    tips21: "Diffie-Hellman/DH 金鑰交換參數",
    tips22: "本地私鑰",
    tips23: "TLS加密秘鑰",
    tips24: "dev tun/tap 裝置",
    addSelect: "新增",
    saveEdit: "保存",
    moreSelect: "--更多選項--",
    selected: "已選擇",
    noFile: "暫無相關文件",
    verb: "冗餘等級",
    port: "端口",
    changeProcessPriority: "改變進程優先權",
    proto: "協議",
    client: "客戶端模式",
    remote: "VPN伺服器",
    keepalive: "保活間隔及空閒時長",
    comp_lzo: "快速LZO壓縮",
    compress: "壓縮",
    cipher: "加密演算法",
    nobind: "無綁定",
    tun_ipv6: "IPv6支援",
    nice: "進程優先權",
    server: '伺服器模式',
    server_bridge: '伺服器橋接',
    dev_type: '裝置類型',
    auth_method: '認證方式',
    auth: '認證參數',
    username: '使用者名稱',
    password: '密碼',
    secret: '靜態金鑰',
    pkcs12: 'PKCS#12檔',
    ca: 'CA根證書',
    dh: '使用DH協議文件',
    cert: '證書',
    key: "私鑰",
    tls_crypt: '使用TLS-共享金鑰',
    authParameter: 'auth參數',
    useStaticKeys: '使用靜態金鑰',
    addtlsauth: '新增tls-auth配置',
    enabletlsauth: '使用TLS認證',
    tlsAuth: 'TLS認證',
    enableDh: '使用DH協定檔',
    addDh: '新增DH配置',
    enablePkcs: '使用PKCS#12檔',
    addPkcs: '新增PKCS#12配置',
    enabletlscrypt: '使用TLS-共享金鑰',
    addtlscrypt: '新增TLS-共用金鑰配置',
    cacert: 'CA根憑證',
    username2: '使用者名稱 密碼',
    usernameCacert: '使用者名稱 密碼+CA憑證',
    dev: '裝置',
  },
  repeater: {
    refsh: "刷新",
    universal: "通用",
    serverConfig: "伺服器設定",
    enable: "啟用",
    operatingModel: "工作模式",
    protocol: '協議',
    serverAddress: "伺服器位址",
    heartbeatCycle: "心跳週期",
    second: "秒",
    state: "狀態",
    noConnect: "未連線",
    connectNumber: "連線數",
    relayConfig: "中繼配置",
    reportTerminal: "上報終端機",
    name: "名稱",
    listenPort: "監聽埠",
    sendTo: "發送至",
    ipRules: "IP1:port IP2port2...#多個ip:port之間由空格隔開",
    del: "刪除",
    add: "新增",
    serailConfig: "串列埠配置",
    interface: "介面",
    baudrate: "波特率",
    data_bits: "資料位元",
    stop_bits: "停止位元",
    parity: "校驗位",
    flow: "流控",
    edit: "編輯",
    adv: "進階",
    advConfig: "進階配置",
    trueOn: "開啟",
    debug: "調試",
    tcpKeep: "TCP保活空閒時長",
    tcpKeep2: "TCP保活探測間隔",
    tcpKeep3: "TCP保活探測最大次數",
    logNumber: "保留日誌檔案個數",
    logSize: "日誌檔案大小",
    logPriority: "日誌優先權",
    info: "訊息",
    notice: "注意",
    warn: "警告",
    error: "錯誤",
    fatal: "致命",
    alert: "警戒",
    urgent: "緊急",
    logFile: "日誌檔",
    download: "下載",
    SaveApply: "儲存並套用",
    numberRuleErr: "請輸入正確的數值",
    ipRuleErr: "ip位址不合法",
    portRuleErr: "連接埠號碼不正確",
    nameRuleErr1: "存在此名稱",
    nameRuleErr2: "0~31之間",
    heartbeatRuleErr: "請輸入心跳週期",
    numberRuleErr2: "請輸入名稱",
    tcpRuleErr: "請輸入TCP保活空閒時長",
    tcpRuleErr2: "請輸入TCP保活偵測間隔",
    tcpRuleErr3: "請輸入TCP保活偵測最大次數",
    logRuleErr: "請輸入保留日誌檔個數",
    logRuleErr2: "請輸入日誌檔案大小",
    saveSuccess: "保存成功",
    seniorErr: "進階設定表單未完善",
    serverErr: "伺服器設定參數不正確",
    repeaterErr: "中繼器配置未完善",
    repeaterErr2: "此裝置暫無中繼器配置",
    sec: "秒"
  },
  IOControl: {
    universal: "通用",
    DIDigitalInput: "DI 數位量輸入",
    deviceName: "裝置名稱",
    pleaseDeviceName: "請輸入裝置名稱",
    interfaceName: "介面名稱",
    deviceState: "裝置狀態",
    DODigitalInput: "DO 數位量輸出",
    start_stop: "啟動/停止",
    close: "關閉",
    open: "開啟",
    relay: "繼電器",
    senior: "高級",
    seniorConfig: "進階配置",
    trueOn: "開啟",
    debug: "調試",
    info: "訊息",
    notice: "注意",
    warn: "警告",
    error: "錯誤",
    fatal: "致命",
    alert: "警戒",
    urgent: "緊急",
    logNumber: "保留日誌檔案個數",
    logSize: "日誌檔案大小",
    logPriority: "日誌優先權",
    logFile: "日誌檔",
    download: "下載",
    SaveApply: "儲存並套用",
    enable: "啟用",
    editSuccess: "修改成功",
    refresh: "刷新",
    msgok: "操作成功",
    msgfaile: "操作失敗",
    disable: "關閉",
    msg1: "請先開啟"
  },
  unit: {
    registerTypeObj1: "讀線圈",
    registerTypeObj2: "讀輸入狀態",
    registerTypeObj3: "讀取保持暫存器",
    registerTypeObj4: "讀輸入暫存器",
    dataFormatObj1: "16位元 無符號",
    dataFormatObj2: "16位元 有符號",
    dataFormatObj3: "16位元 BCD",
    dataFormatObj4: "32位元 無符號(AB CD)",
    dataFormatObj5: "32位元 無符號(CD AB)",
    dataFormatObj6: "32位元 有符號(AB CD)",
    dataFormatObj7: "32位元 有符號(CD AB)",
    dataFormatObj8: "32位元 浮點數(AB CD)",
    dataFormatObj9: "32位元 浮點數(CD AB)",
    dataFormatObj10: "32位元 浮點數(CD AB)",
    dataFormatObj11: "32位元 BCD",
    dataFormatObj12: "32位元 BCD",
    dataFormatObj13: "位元",
    dataFormatObj14: "32位元 時間戳記",
    dataFormatObj15: "32位元 時間戳記",
    ioControlListObj0: "通用型",
    ioControlListObj1: "風扇",
    ioControlListObj2: "光聲警報器",
    ioControlListObj3: "煙霧警報器",
    modbusListObj0: "通用型",
    modbusListObj1: "溫度",
    modbusListObj2: "濕度",
    typeListObj0: "Modbus",
    typeListObj1: "IO控制",
    dataTypeObj1: "16位元 有符號（int16）",
    dataTypeObj2: "16位元 無符號（uint16）",
    dataTypeObj3: "32位元 有符號（int32）",
    dataTypeObj4: "32位元 無符號（uint32）",
    dataTypeObj5: "64位元 有符號（int64）",
    dataTypeObj6: "64位元 無符號（uint64）",
    dataTypeObj7: "浮點數 單精度（float）",
    dataTypeObj8: "浮點數 雙精確度（double）",
    dataTypeObj9: "字串（string）",
    dataTypeObj10: "布林型（bool）",
    dataTypeObj11: "自訂（custom）",
    dataTypeObj12: "時間型別（int64）",
    dataTypeObj13: "raw",
    endianObj1: "高階位元組序（ABCD）",
    endianObj2: "低階位元組序（CDAB）",
    triggerObj2: "週期上報",
    triggerObj3: "狀態變更",
    triggerObj4: "從不上報",
    storageModeObj1: "變化儲存",
    storageModeObj2: "全部儲存",
    rorwObj1: "唯讀",
    rorwObj2: "只寫",
    //
    unitObj1: "攝氏度(℃)",
    unitObj2: "帕(Pa)",
    unitObj3: "伏特(volt)",
    unitObj4: "百分比(%)",
    unitObj5: "毫安(mA)",
    unitObj6: "歐姆(R)",
    unitObj7: "無",
    registerTypeOptions1: "1(線圈狀態)",
    registerTypeOptions2: "2(輸入狀態)",
    registerTypeOptions3: "3(保持暫存器)",
    registerTypeOptions4: "4(輸入暫存器)",
  },
  //警報記錄
  alarmList: {
    serialNumber: "序號",
    devicename: "裝置名稱",
    terminalname: "終端名稱",
    variable: "變數",
    currentvalue: "當前值",
    Triggeringconditions: '觸發條件',
    Notificationinformation: '通知訊息(警報)',
    Notificationinformation2: "通知訊息(恢復)",
    starttime: "警報開始時間",
    endtime: "警報結束時間",
    Alarmstatus: '警報狀態',
    restored: "已恢復",
    inalarm: "警報中",
    operate: "操作",
    Handlingalarms: '處理警報',
    ProcessDescription: '處理描述',
    msg1: '處理成功！ ',
    msg2: '處理失敗！ ',
    msg3: '請求失敗，請重試！ '
  },
  //報警聯絡人
  alarmContact: {
    name: "姓名",
    phone: '手機號碼',
    email: '信箱',
    wechat: "微信",
    Remark: '備註',
    add: "新增",
    EditContact: "編輯聯絡人",
    Addcontacts: '新增聯絡人',
    new: "新增",
    msg1: "請填寫手機號碼",
    msg2: "請填寫信箱",
    msg3: "請輸入姓名",
    msg4: "該手機號碼已存在！",
    msg5: '手機號碼格式不正確',
    msg6: '該信箱已存在！ ',
    msg7: '修改成功！ ',
    msg8: '修改失敗，請重試！ ',
    msg9: '新增成功！ ',
    msg10: '新增失敗，請重試！ ',
    wxandemail: '微信、信箱',
    Shortmessage: '簡訊',
    Emaildoesnot: "郵件信箱不符合格式"
  },
  rightAlarm: {
    Nopermission: '無權限',
    Alarmhandling: '警報處理',
    Alarmstart: '警報開始時間：',
    Alarmend: '警報結束時間：',
    Alarmresult: '警報結果：',
    notprocessed: '未處理',
    Processing: '處理描述：',
    save: '儲存',
    equipment: '設備：',
    terminal: '終端：',
    variable: '變數：',
    content: '內容：',
    msg1: '保存成功！ ',
    msg2: '保存失敗！ ',
    msg3: '請求失敗， 請重試！ '
  },
  networkMonitoring: {
    configuration: '配置',
    enabled: '啟用',
    operatingMode: '操作模式',
    pleaseChoose: '請選擇',
    restartAfterNetworkDisconnection: '斷網重啟',
    periodicRestart: '週期重啟',
    detectionAddress: '檢測位址',
    pleaseEnter: '請輸入',
    detectionCycle: '檢測週期',
    recoveryPeriod: "恢復週期",
    tips1: "偵測網路連線的頻率,單位為秒",
    tips2: " 預設單位為秒，您可以使用'm'作為後綴表示分鐘，‘h’表示小時‘d’表示天。",
    save: '儲存',
    msg1: '取得資料失敗!',
    msg2: '保存成功!',
    msg3: '保存失敗!',
    msg4: '請填入正確的表單',
    repeatCycle: '重複週期',
  },
  //智慧電梯
  smartele: {
    updateInterval: "請填入正確的更新周期",
    log_file_num: "請填入正確的日誌檔案數量",
    log_file_size: "請填入正確的日誌檔案大小",
    server: "伺服器",
    customerID: "客戶ID",
    MQTTQualityofService: "MQTT服務品質",
    sessionCleanup: "會話清理",
    keepInformation: "保留訊息",
    policyConfiguration: "政策配置",
    EscalationPolicy: "上報策略",
    ReportRegularly: "定時上報",
    ChangeReporting: "變化上報",
    ReportAllAttributes: "全屬性上報",
    NonFullAttributeReporting: "非全屬性上報",
    speed: "速度",
    ValueMethod: "取值方式",
    averageValue: "平均值",
    instantaneousValue: "瞬時值",
    timeInterval: "時間間隔",
    ReportingThreshold: "上報閾值",
    acceleration: "加速度",
    barometricPressure: "氣壓",
    TheSamplingPeriod: "採樣週期",
    floatingValue: "浮動值",
    NumberOfFloats: "浮動次數",
    high: "高度",
    temperature: "溫度",
    humidity: "濕度",
    DirectionOfMovement: "運動方向",
    motionTOstill: "運動 -> 靜止",
    stillToMoving: "靜止 -> 運動",
    doorStatus: "門狀態",
    notClosedToClosed: "未關閉 -> 已關閉",
    closedToNotClosed: "已關閉 -> 未關閉",
    flatState: "平層狀態",
    NonFlatLayerToFlatLayer: "非平層 -> 平層",
    FlatLayerToNonFlatLayer: "平層 -> 非平層",
    GrassrootsState: "基底層狀態",
    NonGrassrootsToGrassroots: "非基層 -> 基層",
    GrassrootsToNonGrassroots: "基層 -> 非基層",
    PersonnelStatus: "人員狀態",
    noOneToSomeone: "無人 -> 有人",
    someoneToNoOne: "有人 -> 無人",
    SerialPortConfiguration: "串列埠配置",
    DataUpdateCycle: "資料更新周期",
    // 錯誤提示
    errorMsg: "請輸入正確的值",
    LOGOFacingUp: 'LOGO朝上',
    toward: '朝向',
    lightUp: '指示燈朝上'
  },
  // sms簡訊
  smartsms: {
    configuration: '配置',
    inbox: '收件匣',
    outbox: '寄件匣',
    advanced: '高級',
    mobileNetwork: '行動網路',
    SIM1Number: 'SIM1號碼',
    storageLocation: '儲存位置',
    SIMCard: 'SIM卡',
    equipmentTerminal: '設備終端',
    SMSCenter: '簡訊中心',
    tips1: "國際區號+手機號碼，如861380013800",
    whitelist: '白名單',
    validityPeriod: '有效期限',
    DetectionCycle: '接收偵測週期',
    saveAndApply: '儲存並套用',
    overview: '概覽',
    thresholdManagement: '閾值管理',
    storeState: '儲存狀態',
    CurrentSIMCard: "目前SIM卡",
    messageList: '簡訊列表',
    serialNumber: '序號',
    telephoneNumber: '電話號碼',
    SMSContent: '簡訊內容',
    date: '日期',
    merge: '合併',
    no: '否',
    yes: '是',
    delete: '刪除',
    tips2: '此操作將永久刪除該訊息, 是否繼續?',
    tips: '提示',
    sure: '確定',
    cancel: '取消',
    state: '狀態',
    edit: '編輯',
    發送: '發送',
    tips3: "最大允許1500位元組長度",
    saveAsDraft: '儲存草稿',
    sendImmediately: '立即發送',
    FailedToSend: '發送失敗',
    SentSuccessfully: "發送成功",
    sending: '發送中',
    draft: '草稿',
    advancedConfiguration: '進階配置',
    notConnect: '暫無連線'
  },
  webssh: {
    connect: '連線',
    newWindwo: '新視窗中開啟',
    disconnect: '斷開',
    tunnel: '隧道建立中',
    disconnectLoading: '斷開連線中',
    'DeviceMQTToffline': '設備MQTT不在線',
    'Failedtoobtainterminaladdress': '取得終端位址失敗',
    tunnelErr: '連接隧道失敗，請檢查網路或設備狀態',
    Unexpecteddisconnection: '意外斷開連線',
    SelectRoute: "選擇線路",
    DEFAULT: "預設",
    ChinaMobile: "中國移動",
    ChinaTelecom: "中國電信"
  }
};